var map = {
	"./alloy.mp3": "eaa3",
	"./echo.mp3": "95f3",
	"./fable.mp3": "9f82",
	"./nova.mp3": "1e7c",
	"./onyx.mp3": "0f99",
	"./shimmer.mp3": "5a77"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5ea";